export default __webpack_public_path__ + "static/media/superavitIcon.0f5fb5b3.svg";